import React from 'react';
import {
  IFixedIncomeAggregateDataMaximised,
  IFixedIncomeAggregateDataMinimised,
  generateAggregateColumns,
  generateAggregateData,
} from '../table/table.data';
import { useWindowSize } from '../../../../../hooks/useWindowSize';
import GridItem from '../../../../layout/GridComponents/GridItem';
import SlimTable from '../../../../tables/SlimTable';
import { FixedIncomePages } from '../FixedIncome';
import { BondDataServer } from '../table/table.data';

interface AggregateTable {
  fixedIncomeData: BondDataServer;
  isFetching: boolean;
  currentPage: FixedIncomePages;
}
const AggregateFixedIncomeTable = (props: AggregateTable) => {
  const { width } = useWindowSize();

  const widthForUse = props.currentPage === 'exposureGraphics' ? 1919 : width;
  const aggData = generateAggregateData(props.fixedIncomeData, widthForUse);
  const aggregateColumns = generateAggregateColumns(widthForUse);

  const csvFields =
    widthForUse <= 1919
      ? ['nav', 'exposure', 'exposurePc', 'dv01', 'wam', 'wac', 'duration']
      : ['parameter', 'value', 'yield'];

  return (
    <GridItem
      card
      xs={12}
      xl={props.currentPage === 'exposureGraphics' ? 12 : 2}
      style={{
        display: 'flex',
        alignSelf: 'stretch',
      }}
    >
      <SlimTable<
        IFixedIncomeAggregateDataMinimised | IFixedIncomeAggregateDataMaximised
      >
        data={aggData}
        loading={props.isFetching}
        columns={aggregateColumns}
        csvFields={csvFields}
        title="Aggregate Data"
        export={true}
      />
    </GridItem>
  );
};

export default AggregateFixedIncomeTable;
